<template>
  <div v-for="a in reslutData" :key="a.subId" class="nav-item">
    <div
      :style="{
        paddingLeft: a.children ? a.num * 15 + 'px' : '15px',
        fontWeight: '400',
        fontSize: '14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'start',
        position: 'relative',
        width:'100%',
        height: '100%',
        cursor: 'default',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center'
      }"
      class="a-item"
    >
      <a
        :href="`${'#' + a.subId}`"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="false"
        :aria-controls="a.subId"
        :data-key="a.name"
        class="text-dark"
        @click="changeType(a)"
      >
        <i style="margin-left: 20px"></i>
        <i
          :class="[
            'fs-12',
            a.iconType ? ' bx bxs-down-arrow' : 'bx bxs-right-arrow',
          ]"
          style="color: #fff; position: absolute; top: 3px; left: 5px"
        ></i>
      </a>
      <div
        style="display: inline-block; width: 90%; display: flex;alignItems: center;alignContent:center"
      >
        <span>{{ a.name }}</span>
      </div>
    </div>
    <div :class="['collapse', 'show']" :id="a.subId">
      <div
        :style="{
          paddingLeft: a.children ? a.num * 30 + 10 +'px' : '25px',
          cursor: 'default',
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center'
        }"
        v-for="b in a.attributes&&a.attributes.measurements"
        :key="b.name"
        class="a-item"
      >
      <input class="form-check-input me-1 mt-0 p-0" type="checkbox" v-model="b.is_checked" @change="singleChecked(b,a)"/>
        <img
          src="../assets/images/value-white.svg"
          style="width: 20px; height: 16px"
          alt=""
        />
        {{ b.name }}
      </div>
      <CockpitTree
        :dataList="a.children"
        :chartIndex="chartIndex"
        @saveInstancesSetting="selectedsChildrenChecked"
      ></CockpitTree>
    </div>
  </div>
</template>

<script>
import _ from "loadsh";
export default {
  emits:["saveInstancesSetting"],
  props: ['dataList',"chartIndex"],
  name:'CockpitTree',
  data() {
    return {
      itemSelecteds: "",
      warnStatusList: ["health", "sub-health", "error", "unknown"],
      reslutData: [],
    };
  },
  watch: {
    dataList: {
      handler(val) {
        if (val) {
          this.reslutData = _.cloneDeep(val);
          this.reslutData.forEach((i) => {
            if (i.attributes && i.attributes.measurements) {
              i.attributes.measurements.forEach((item, index) => {
                if (this.chartIndex&&this.chartIndex.findIndex((item) => item == index) > -1) {
                  item.is_checked = true;
                } else {
                  item.is_checked = false;
                }
              });
            }
          });
        }
      },immediate:true
    },
  },
  methods: {
    changeType(item) {
      item["iconType"] = !item["iconType"];
    },
    selectedsDetail(item, aItem) {
      this.$emit("getDetailId", item, aItem);
    },
    singleChecked(item, aItem){
      // item.is_checked = !item.is_checked;
      
      let list = aItem.attributes.measurements,
        indexs = [];
      list.forEach((it_, i) => {
        /* 遍历出投选状态下测点索引数组 */
        if (it_.is_checked) {
          indexs.push(i);
        }
      });
      if(indexs.length>2){
        item.is_checked = false;
        return;
      }
      this.$emit("saveInstancesSetting",indexs)
    },
    selectedsChildrenChecked(indexs){
      this.$emit("saveInstancesSetting",indexs)
    }
  },
  created() {},
  mounted() {
  
    
  },
};
</script>

<style lang="scss" scoped>
.form-check-input{
  background: #000;
}
.form-check-input:checked{
  background: #0ED1D5;
  border-color: #0ED1D5;
}
.a-item{
  padding-top:5px;
  padding-bottom:5px;
}
.a-item:hover {
  background: #212B33;
  cursor: default;
}
</style>
